<template>
    <div>
        Sustainability Page
    </div>
</template>